export const stringSlice = (start: number, end: number) => (
  word: string
): string => word.slice(start, end);
